/* eslint-disable import/prefer-default-export */
import {
  GET_DASHBOARD_LIST, GET_DASHBOARD_URLS, SET_CURRENT_DASHBOARD, GET_SAGEMAKER_URL,
} from '../../types/Types';

export const getDashboardList = (data) => ({
  type: GET_DASHBOARD_LIST,
  data,
});

export const getDashboardURLS = (data) => ({
  type: GET_DASHBOARD_URLS,
  data,
});

export const setCurrentDashboard = (data) => ({
  type: SET_CURRENT_DASHBOARD,
  ...data,
});

export const getSageMaker = (data, requestType) => ({
  type: GET_SAGEMAKER_URL,
  data,
  requestType,
});
